"use strict";

define('view/assign.reviewer.overlay',['underscore', 'marionette', 'uikit/uikit', 'uikit/collections/container', 'uikit/elements/button', 'uikit/elements/checkbox', 'uikit/modules/loader', 'uikit/elements/dropdown', 'uikit/collections/table', 'uikit/elements/text', 'uikit/modules/message', 'uikit/elements/label', 'uikit/mixins/component.mixin', '../libs/format/empty', '../model/board.member', '../collection/base', '../templates'], function (_, Mn, UIKit, Container, ButtonView, CheckboxView, LoaderView, DropdownView, TableView, TextView, MessageView, LabelView, ComponentMixin, EmptyFormatter, BoardMember, BaseCollection, Templates) {
  var emptyFormat = EmptyFormatter('--');
  var AssignReviewerOverlay = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    className: 'ui grid',
    template: Templates.IRB['assign.overlay'],
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this.setupForm();
      this.setupFormListeners();
    },
    setupForm: function setupForm() {
      var form = this.form,
        assignments = this.options.assignments;
      reviewType = assignments.getByAssignmentTypeProp('IRB_REVIEW_TYPE', 'description').models[0], isFullExpeditedFlag = assignments.getByAssignmentTypeProp('IRB_IS_FULL_EXPEDITED', 'description').models[0], isFullExpedited = isFullExpeditedFlag ? isFullExpeditedFlag.get('value') : 'false', reviewerType = assignments.getByAssignmentTypeProp('IRB_FULL_EXPEDITED_REVIEW_TYPE', 'description').models[0] || assignments.getByAssignmentTypeProp('IRB_EXEMPT_TYPE', 'description').models[0];
      board = assignments.getByAssignmentTypeProp('IRB_BOARD', 'description').models[0], primaryReviewer = assignments.getByAssignmentTypeProp('IRB_REVIEWER_PRIMARY', 'description').models[0], secondaryReviewer = assignments.getByAssignmentTypeProp('IRB_REVIEWER_SECONDARY', 'description').models[0], fullExpReviewer = assignments.getByAssignmentTypeProp('IRB_FULL_EXPEDITED_REVIEWER', 'description').models[0], reviewers = assignments.getByAssignmentTypeProp('IRB_REVIEWER', 'description') || new BaseCollection(), isFullBoardReview = this.isFullBoardReview(), boardMembersWoConflicts = this.options.boardMembers.filter(function (b) {
        return !b.get('conflictOfInterest');
      }), primaryBoardMemberOps = {
        name: 'primaryBoardMember',
        placeholder: 'Select a Member',
        collection: this.options.boardMembers,
        childBindings: {
          text: 'personDisplayName',
          disabled: 'conflictOfInterest',
          description: 'conflictOfInterest'
        },
        clearable: true
      }, secondaryBoardMembersOps = {
        name: 'secondaryBoardMember',
        placeholder: 'Select a Member',
        collection: this.options.boardMembers,
        childBindings: {
          text: 'personDisplayName',
          disabled: 'conflictOfInterest',
          description: 'conflictOfInterest'
        },
        clearable: true,
        disabled: true
      }, fullExpReviewerOps = {
        name: 'fullExpReviewer',
        placeholder: 'Select a Reviewer',
        clearable: true
      }, primaryReviewerOps = {
        name: 'primaryReviewer',
        placeholder: 'Select a Reviewer',
        clearable: true,
        search: true
      }, boardRosterOps = {
        name: 'boardRoster',
        collection: this.options.boardMembers,
        columns: [{
          text: 'Assign',
          childView: CheckboxView,
          onBeforeAdd: setupAssignColumn
        }, {
          text: 'Name',
          childView: Container,
          onBeforeAdd: setupDisplayName
        }, {
          text: 'Membership',
          data: 'membership',
          formatter: emptyFormat
        }, {
          text: 'Degrees',
          data: 'degrees',
          formatter: emptyFormat
        }, {
          text: 'Status',
          data: 'scientificStatus',
          formatter: emptyFormat
        }, {
          text: 'Representation',
          data: 'representation',
          formatter: emptyFormat
        }, {
          text: 'Affiliation',
          data: 'affiliation',
          formatter: emptyFormat
        }, {
          text: 'Office',
          data: 'office',
          formatter: emptyFormat
        }, {
          text: 'Alternate For',
          data: 'alternatesFor'
        }],
        sortable: false,
        tabletStackable: true
      };
      var self = this;
      this._alternates = [];
      this._alternatesMap = {};
      function setupDisplayName(container, model) {
        var conflictOfInterest = model.get('conflictOfInterest');
        container.empty();
        container.add(new TextView({
          text: model.get('personDisplayName')
        }));
        if (conflictOfInterest) {
          container.add(new (Container.extend({
            tagName: 'br'
          }))()).add(new LabelView({
            text: 'Conflict',
            color: 'red'
          }));
        }
      }
      function setInitialAlternateFor(assignment) {
        if (assignment && assignment.get('alternateFor')) {
          self._alternatesMap[assignment.get('person').id] = assignment.get('alternateFor');
        }
      }
      if (board && !boardMembersWoConflicts.length) {
        form.state = 'error';
        form.add(new MessageView({
          format: 'error',
          text: 'The board "' + board.get('group').get('name') + '" does not contain any available board members.'
        }));
      }
      if (boardMembersWoConflicts.length) {
        setInitialAlternateFor(primaryReviewer);
        setInitialAlternateFor(secondaryReviewer);
        setInitialAlternateFor(fullExpReviewer);
        if (isFullBoardReview) {
          this._reviewers = new BaseCollection(boardMembersWoConflicts.slice(0));
        } else {
          this._reviewers = new BaseCollection(_.map(reviewers.models, function (r) {
            setInitialAlternateFor(r);
            return self.options.boardMembers.find(function (b) {
              return b.get('person').get('id') == r.get('personId');
            });
          }));
        }
      }
      function getBoardMember(person) {
        return self.options.boardMembers.find(function (b) {
          return b.get('person').get('id') == person.get('id');
        });
      }
      ;
      function getAnalyst(person) {
        return self.options.analysts.find(function (a) {
          return a.get('id') == person.get('id');
        });
      }
      ;
      function setupAssignColumn(checkbox, model) {
        var isReviewer = self._reviewers.indexOf(model) > -1,
          row = checkbox.options.rowView;
        checkbox.toggle = true;
        checkbox.model = model;
        if (isFullBoardReview) {
          checkbox.disabled = true;
          checkbox.value = !model.get('conflictOfInterest');
        } else {
          checkbox.disabled = model.get('conflictOfInterest');
        }
        if (isReviewer) {
          checkbox.value = true;
        }
        checkbox.on('change:value', function () {
          if (checkbox.value) {
            self._reviewers.push(checkbox.model);
          } else {
            self._reviewers.remove(checkbox.model);
          }
        });
        checkbox.listenTo(row, 'double:press', function () {
          if (!checkbox.model.get('conflictOfInterest') && !isFullBoardReview) {
            checkbox.value = !checkbox.value;
          }
        });
      }
      var assignPrimaryField = form.addField({
        text: 'Primary Reviewer',
        visible: false
      }, new DropdownView(primaryBoardMemberOps));
      var assignSecondaryField = form.addField({
        text: 'Secondary Reviewer',
        visible: false
      }, new DropdownView(secondaryBoardMembersOps));
      var assignFullExpReviewerField = form.addField({
        text: 'Primary Reviewer',
        visible: false,
        required: true
      }, new DropdownView(fullExpReviewerOps));
      var assignPrimaryReviewerField = form.addField({
        text: 'Primary Reviewer',
        visible: false
      }, new DropdownView(primaryReviewerOps));
      if (reviewType.get('value') == 'EXEMPT') {
        assignPrimaryReviewerField.required = true;
      }
      var boardRosterField = form.addField({
        text: 'Reviewers',
        visible: false
      }, new TableView(boardRosterOps));
      if (boardMembersWoConflicts.length) {
        this.setupAlternateListeners();
        _.defer(function () {
          self.setupInitialAlternateValues();
        });
      }
      form.boardRoster.$el.addClass('unselectable');
      switch (reviewType.get('value')) {
        case 'FULL':
          if (isFullExpedited != 'true') {
            assignPrimaryField.visible = true;
            assignSecondaryField.visible = true;
            form.primaryBoardMember.value = primaryReviewer ? getBoardMember(primaryReviewer.get('person')) : null;
            form.secondaryBoardMember.value = secondaryReviewer ? getBoardMember(secondaryReviewer.get('person')) : null;
            if (primaryReviewer) {
              form.secondaryBoardMember.disabled = false;
            }
            boardRosterField.text = 'All non-conflicting board members will be assigned as Reviewers';
            boardRosterField.visible = true;
          } else {
            assignFullExpReviewerField.visible = true;
            if (reviewerType.get('value') == 'IRB_BOARD') {
              boardRosterField.visible = true;
              form.fullExpReviewer.collection = this.options.boardMembers;
              form.fullExpReviewer.childBindings = {
                text: 'personDisplayName',
                disabled: 'conflictOfInterest',
                description: 'conflictOfInterest'
              };
              form.fullExpReviewer.value = fullExpReviewer ? getBoardMember(fullExpReviewer.get('person')) : null;
            } else {
              form.fullExpReviewer.collection = this.options.analysts;
              form.fullExpReviewer.childBindings = {
                text: 'displayName'
              };
              form.fullExpReviewer.value = fullExpReviewer ? getAnalyst(fullExpReviewer.get('person')) : null;
            }
          }
          break;
        case 'EXPEDITED':
        case 'LIMITED':
        case 'ADMINISTRATIVE':
          assignPrimaryReviewerField.visible = true;
          boardRosterField.visible = true;
          form.primaryReviewer.collection = this.options.boardMembers;
          form.primaryReviewer.childBindings = {
            text: 'personDisplayName',
            disabled: 'conflictOfInterest',
            description: 'conflictOfInterest'
          };
          form.primaryReviewer.value = primaryReviewer ? getBoardMember(primaryReviewer.get('person')) : null;
          break;
        case 'EXEMPT':
          assignPrimaryReviewerField.visible = true;
          if (reviewerType.get('value') == 'IRB_BOARD') {
            boardRosterField.visible = true;
            form.primaryReviewer.collection = this.options.boardMembers;
            form.primaryReviewer.childBindings = {
              text: 'personDisplayName',
              disabled: 'conflictOfInterest',
              description: 'conflictOfInterest'
            };
            form.primaryReviewer.value = primaryReviewer ? getBoardMember(primaryReviewer.get('person')) : null;
          } else {
            form.primaryReviewer.collection = this.options.analysts;
            form.primaryReviewer.childBindings = {
              text: 'displayName'
            };
            form.primaryReviewer.value = primaryReviewer ? getAnalyst(primaryReviewer.get('person')) : null;
          }
        default:
          break;
      }
    },
    getBoardMembersWithoutConflicts: function getBoardMembersWithoutConflicts() {
      return new BaseCollection(this.options.boardMembers.filter(function (b) {
        return !b.get('conflictOfInterest');
      }));
    },
    getAssignments: function getAssignments() {
      var newAssignments = [],
        form = this.form,
        assignments = this.options.assignments,
        reviewType = assignments.getByAssignmentTypeProp('IRB_REVIEW_TYPE', 'description').models[0],
        board = assignments.getByAssignmentTypeProp('IRB_BOARD', 'description').models[0],
        primaryReviewer = form.primaryBoardMember.value || form.primaryReviewer.value,
        secondaryReviewer = form.secondaryBoardMember.value,
        fullExpReviewer = form.fullExpReviewer.value,
        boardMembers = new BaseCollection(this.options.boardMembers.filter(function (b) {
          return !b.get('conflictOfInterest');
        })),
        reviewers = this._reviewers;
      board = board ? board.get('group') : null;
      newAssignments.push({
        type: 'IRB_FULL_EXPEDITED_REVIEWER',
        person: fullExpReviewer && fullExpReviewer.get('person') ? fullExpReviewer.get('person') : fullExpReviewer,
        group: fullExpReviewer ? board : null
      });
      newAssignments.push({
        type: 'IRB_REVIEWER_PRIMARY',
        person: primaryReviewer && primaryReviewer.get('person') ? primaryReviewer.get('person') : primaryReviewer,
        group: primaryReviewer ? board : null
      });
      newAssignments.push({
        type: 'IRB_REVIEWER_SECONDARY',
        person: secondaryReviewer ? secondaryReviewer.get('person') : null,
        group: secondaryReviewer ? board : null
      });
      reviewers = reviewers && reviewers.pluck('person');
      if (reviewers && reviewers.length) {
        for (var i = 0, len = reviewers.length; i < len; i++) {
          newAssignments.push({
            type: 'IRB_REVIEWER',
            person: reviewers[i],
            group: board
          });
        }
      } else {
        newAssignments.push({
          type: 'IRB_REVIEWER'
        });
      }
      this.setAssignmentsAlternateFor(newAssignments);
      return newAssignments;
    },
    validateForm: function validateForm() {
      var assignments = this.getOption('assignments'),
        form = this.form,
        reviewers = {
          primaryReviewer: form.primaryBoardMember.value || form.primaryReviewer.value,
          secondaryReviewer: form.secondaryBoardMember.value,
          fullExpReviewer: form.fullExpReviewer.value,
          reviewers: this._reviewers
        },
        alternates = this._alternates,
        assignmentService = app.service('assignment'),
        errors = assignmentService.validateReviewerAssignments(assignments, reviewers);
      form.errors.reset([]);
      var alternate = null,
        alternateDp = null,
        alternateDpName = '';
      for (var i = 0, len = alternates.length; i < len; i++) {
        alternate = alternates[i];
        alternateDpName = 'alternateFor' + alternate.get('person').get('id');
        alternateDp = this.form[alternateDpName];
        if (alternateDp) {
          var alternatingFor = alternateDp.value ? alternateDp.value.id : null;
          if (alternatingFor == null) {
            errors.push({
              field: alternateDpName,
              error: 'Specify who ' + alternate.get('person').get('displayName') + ' is an alternate for.'
            });
          } else {
            var validAlternateFor = true;
            if (reviewers.primaryReviewer && alternatingFor == reviewers.primaryReviewer.get('person').id) {
              validAlternateFor = false;
            }
            if (this.isFullBoardReview()) {
              if (reviewers.secondaryReviewer && alternatingFor == reviewers.secondaryReviewer.get('person').id) {
                validAlternateFor = false;
              }
            } else {
              if (reviewers.fullExpReviewer && alternatingFor == reviewers.fullExpReviewer.get('person').id) {
                validAlternateFor = false;
              }
              if (_.pluck(reviewers.reviewers.pluck('person'), 'id').indexOf(alternatingFor) > -1) {
                validAlternateFor = false;
              }
            }
            if (!validAlternateFor) {
              errors.push({
                field: alternateDpName,
                error: 'The person you are alternating for cannot be a selected reviewer.'
              });
            }
          }
        }
      }
      if (errors && errors.length) {
        form.errors.reset(errors);
        this.scrollToError(errors[0]);
        return false;
      }
      return true;
    },
    scrollToError: function scrollToError(error) {
      var container = app.overlay.$el.find('.offset'),
        overlayBtns = 77,
        el = this.form.getFieldByName(error.field).$el;
      container.scrollTop(el.position().top + overlayBtns);
    },
    setupFormListeners: function setupFormListeners() {
      var form = this.form,
        boardMembers = this.options.boardMembers,
        self = this;
      function filterBoardMembers(value) {
        var filteredMembers = value ? new BaseCollection(boardMembers.reject(value)) : boardMembers;
        self._reviewers.remove(value);
        form.boardRoster.collection = filteredMembers;
      }
      function filterFullBoardMembers(value) {
        var primaryBoardMember = form.primaryBoardMember.value,
          secondaryBoardMember = form.secondaryBoardMember.value,
          filteredMembers = new BaseCollection(boardMembers.models);
        if (primaryBoardMember) {
          filteredMembers.reset(filteredMembers.reject(primaryBoardMember));
        }
        if (secondaryBoardMember) {
          filteredMembers.reset(filteredMembers.reject(secondaryBoardMember));
        }
        self._reviewers.reset(filteredMembers.filter(function (b) {
          return !b.get('conflictOfInterest');
        }));
        form.boardRoster.collection = filteredMembers;
      }
      if (boardMembers.length) {
        if (this.isFullBoardReview()) {
          filterFullBoardMembers();
          this.listenTo(form.primaryBoardMember, 'change:value', function () {
            var value = form.primaryBoardMember.value,
              filteredMembers = value ? new BaseCollection(boardMembers.reject(value)) : boardMembers;
            form.secondaryBoardMember.collection = filteredMembers;
            if (value) {
              form.secondaryBoardMember.disabled = false;
            } else {
              form.secondaryBoardMember.disabled = true;
              form.secondaryBoardMember.value = null;
            }
          });
          this.listenTo(form.secondaryBoardMember, 'change:value', function () {
            var value = form.secondaryBoardMember.value,
              filteredMembers = value ? new BaseCollection(boardMembers.reject(value)) : boardMembers;
            form.primaryBoardMember.collection = filteredMembers;
          });
          form.primaryBoardMember.trigger('change:value');
          form.secondaryBoardMember.trigger('change:value');
          this.listenTo(form.primaryBoardMember, 'change:value', filterFullBoardMembers);
          this.listenTo(form.secondaryBoardMember, 'change:value', filterFullBoardMembers);
        } else {
          filterBoardMembers(form.fullExpReviewer.value || form.primaryReviewer.value);
          this.listenTo(form.fullExpReviewer, 'change:value', function (view, value) {
            filterBoardMembers(value);
          });
          this.listenTo(form.primaryReviewer, 'change:value', function (view, value) {
            filterBoardMembers(value);
          });
        }
      }
    },
    isFullBoardReview: function isFullBoardReview() {
      var assignments = this.getOption('assignments'),
        reviewType = assignments.getByAssignmentTypeProp('IRB_REVIEW_TYPE', 'description').models[0].get('value'),
        isFullExpFlag = assignments.getByAssignmentTypeProp('IRB_IS_FULL_EXPEDITED', 'description').models[0],
        isFullExpedited = isFullExpFlag ? isFullExpFlag.get('value') : 'false';
      return reviewType == 'FULL' && isFullExpedited == 'false';
    },
    setAssignmentsAlternateFor: function setAssignmentsAlternateFor(assignments) {
      var assignment = null,
        alternateFor = null,
        alternatesMap = this._alternatesMap,
        isFullBoardReview = this.isFullBoardReview();
      function getAlternateFor(assignment) {
        var person = assignment.person;
        if (person) {
          return alternatesMap[person.id];
        }
        return null;
      }
      for (var j = 0, len = assignments.length; j < len; j++) {
        assignment = assignments[j];
        alternateFor = getAlternateFor(assignment);
        if (isFullBoardReview && assignment.type == 'IRB_REVIEWER') {
          return;
        }
        if (alternateFor) {
          assignment.alternateFor = alternateFor;
        }
      }
    },
    setupAlternateListeners: function setupAlternateListeners() {
      var form = this.form,
        isFullBoard = this.isFullBoardReview(),
        self = this;
      var updateAlternates = _.bind(_.debounce(this.updateAlternateDropdowns), this);
      this._alternatesGroup = form.addGroup({
        autoSize: false
      });
      function chooseAlternateFor(value) {
        if (value && value.get('membership') == 'Alternate') {
          var alternatesFor = value.alternatesForCollection();
          if (alternatesFor.length == 1) {
            self._alternatesMap[value.get('person').id] = alternatesFor.at(0);
          }
          return true;
        }
        return false;
      }
      function cacheAlternate(value, oldValue) {
        var alternates = self._alternates,
          alternatesFor = value,
          oldIndex = alternates.indexOf(oldValue);
        if (oldIndex > -1) {
          self._alternatesMap[oldValue.get('person').id] = null;
          alternates.splice(oldIndex, 1);
        }
        if (chooseAlternateFor(value)) {
          if (alternates.indexOf(value) == -1) {
            alternates.push(value);
          }
        }
        updateAlternates();
      }
      if (isFullBoard) {
        this.listenTo(form.primaryBoardMember, 'change:value', function (view, value, oldValue) {
          cacheAlternate(value, oldValue);
        }).listenTo(form.secondaryBoardMember, 'change:value', function (view, value, oldValue) {
          cacheAlternate(value, oldValue);
        });
      } else {
        this.listenTo(form.primaryReviewer, 'change:value', function (view, value, oldValue) {
          _.defer(function () {
            cacheAlternate(value, oldValue);
          });
        }).listenTo(form.fullExpReviewer, 'change:value', function (view, value, oldValue) {
          _.defer(function () {
            cacheAlternate(value, oldValue);
          });
        });
        for (var i = 0, len = this._reviewers.length; i < len; i++) {
          cacheAlternate(this._reviewers.at(i), null);
        }
        this.listenTo(this._reviewers, 'add', function (reviewer, collection) {
          cacheAlternate(reviewer, null);
        }).listenTo(this._reviewers, 'remove', function (reviewer, collection) {
          cacheAlternate(null, reviewer);
        });
      }
    },
    setupInitialAlternateValues: function setupInitialAlternateValues() {
      var alternates = _.keys(this._alternatesMap),
        form = this.form,
        dp = null;
      for (var a = 0, len = alternates.length; a < len; a++) {
        dp = form['alternateFor' + alternates[a]];
        if (dp) {
          dp.value = this._alternatesMap[alternates[a]];
        }
      }
    },
    updateAlternateDropdowns: function updateAlternateDropdowns() {
      var alternate = null,
        alternates = this._alternates,
        alternateDp = null,
        group = this._alternatesGroup,
        value = null,
        self = this;
      group.empty();
      if (alternates.length) {
        group.add(new TextView({
          tagName: 'h3',
          text: 'Assign Alternates'
        }));
      }
      for (var i = 0, len = alternates.length; i < len; i++) {
        var alternateField = null;
        alternate = alternates[i];
        value = alternate.alternatesForCollection();
        alternateDp = new DropdownView({
          name: 'alternateFor' + alternate.get('person').get('id'),
          model: alternate,
          collection: value,
          childBindings: {
            text: 'displayName'
          },
          placeholder: 'Select a member',
          value: this._alternatesMap[alternate.get('person').get('id')]
        });
        alternateField = group.addGroup({
          size: 16
        }).addField({
          text: alternate.get('person.displayName') + ' is an alternate for',
          required: true,
          width: 16
        }, alternateDp);
        alternateField.getOption('parent').$el.css({
          'margin-bottom': '1em'
        });
        (function (dp, a) {
          self.listenTo(dp, 'change:value', function (view, value) {
            if (value) {
              self._alternatesMap[a.get('person').id] = value;
            } else {
              delete self._alternatesMap[a.get('person').id];
            }
          });
        })(alternateDp, alternate);
      }
    }
  });
  return AssignReviewerOverlay;
});

